import React from 'react';
import { Route } from 'react-router-dom';
import UsersPageRoute from './UsersPageRoute';
import ShelfPageRoute from './ShelfPageRoute';

const basePath = '/v2/users/:userId';

export default (
  <Route path={basePath}>
    <UsersPageRoute>
      <Route path={`${basePath}/shelves/:shelfName`}>
        <ShelfPageRoute />
      </Route>
    </UsersPageRoute>
  </Route>
);
